import { Language } from "../languages/labels/language.labels"
import { AccountingAccount } from "../models/accounting.account.model"
import { AccountingEntry } from "../models/accounting.entry.model"
import { TreasuryAccount } from "../models/treasury.account.model"
import { Address } from "../models/address.model"
import { Contact } from "../models/contact.model"
import { Currency } from "../models/currency.model"
import { Customer } from "../models/customer.model"
import { Deadline } from "../models/deadline.model"
import { Provider } from "../models/provider.model"
import { dateFormatLocalized } from "./datetime.format.script"
import { deadlineTypeValue } from "../libraries/deadline.type.library"
import { countryName } from "../libraries/country.library"
import { treasuryAccountSelected } from "./list.selected.item.script"

export function deadlineFormat(lang: Language, deadline: Deadline): string {
  return `${deadline.quantity} ${deadlineTypeValue(lang, deadline.type, deadline.quantity > 1).toLowerCase()}`
}

export function accountingEntryFormat(lang: Language, treasury_accounts: TreasuryAccount[], currency: Currency, entry: AccountingEntry): string {
  return `${dateFormatLocalized(lang.code, entry.date)}, ${treasuryAccountSelected(lang, treasury_accounts, entry.debits[0].reference.id_treasury_account)}, ${currency.symbol} ${moneyFormat(entry.balance)}`
}

export function numberAddressFormat(lang_labels: any, number: string): string {
  return (number === 'NN' || number === 'nn') ? lang_labels.noNumber : number.toUpperCase()
}

export function addressFormat(lang_code: string, address: Address): string {
  return `${address.number} ${address.street}, ${address.zip_code}, ${address.city}, ${countryName(lang_code, address.country)}`
}

export function accountingAccountFormat(account: AccountingAccount, company_language: string): string {
  return `${account.code}, ${account.name[company_language.toLowerCase() as keyof typeof account.name]}`
}

export function contactFormat(contact: Contact | Customer | Provider): string {
  return (contact.type === "person") ? `${contact.data.first_name} ${contact.data.last_name}` : `${contact.data.name}`
}

export function currencyFormat(currency: Currency): string {
  return `${currency.code}: ${currency.name} (${currency.symbol})`
}

export function taxRateFormat(tax_rate: string): string {
  return (Number(tax_rate) || Number(tax_rate) === 0) ? `${parseFloat(Number(tax_rate).toFixed(2))} %` : `${tax_rate.charAt(0).toUpperCase() + tax_rate.slice(1)}`
}

export function moneyFormat(amount: number): string {
  if (amount) {
    let amountInteger: string = new Intl.NumberFormat("en-US").format(Math.trunc(amount))
    let amountDecimal: string = amount.toFixed(2).toString().split(".")[1]
    return `${amountInteger}.${amountDecimal}`
  } else {
    return '0.00'
  }
}

export function percentageFormat(amount: number): string {
  return (amount === 100) ? `${amount}%` : `${amount.toFixed(2)}%`
}

export function bicFormat(bic: string): string {
  let value: string = ''

  if (bic.length > 0) {
    value = `${bic.substring(0, 4)} ${bic.substring(4, 6)} ${bic.substring(6, 8)} ${bic.substring(8, bic.length)}`
  }

  return value
}

export function ibanFormat(iban: string): string {
  let value: string = ''

  if (iban.length > 0) {
    let array = iban.match(/.{1,4}/g) as string[]

    for (let i = 0; i < array.length; i++) {
      if (i < array.length - 1) {
        value += `${array[i]} `
      } else {
        value += `${array[i]}`
      }
    }
  }

  return value
}
